export class Events {
  static USER_UPDATE = 'user_update';
  static CONTENT_UPDATE = 'content_update';
  static PLAYER_CONTROLS_SHOW = 'player_controls_show';
  static PLAYER_CONTROLS_HIDE = 'player_controls_hide';
  static PLAYER_READY = 'player_ready';
  static PLAYER_PLAY = 'player_play';
  static PLAYER_PAUSE = 'player_pause';
  static PLAYER_STOP = 'player_stop';
  static PLAYER_SEEK = 'player_seek';
  static PLAYER_VOLUME = 'player_volume';
  static PLAYER_FULLSCREEN = 'player_fullscreen';
  static PLAYER_ENDED = 'player_ended';
  static PLAYER_ERROR = 'player_error';
  static PLAYER_RELOADED = 'player_reloaded';
  static CAST_STATUS_CHANGE = 'cast_status_change';
  static CAST_AVAILABLE = 'cast_available';
  static CAST_MESSAGE = 'cast_message';
  static PLAYBACK_LEVELS_AVAILABLE = 'playback_levels_available';
}